import { SnippetScope, type Snippet } from '@atlassian/editor-snippets-provider/types';

const isValidQuickInsertSnippet = (snippet: Snippet): boolean =>
	Boolean(snippet.isCreatedByCurrentUser) ||
	snippet.scope === SnippetScope.GLOBAL ||
	snippet.isFavorite;

const getSortPriority = (snippet: Snippet): number => {
	if (snippet.isCreatedByCurrentUser) {
		return 0;
	}

	if (snippet.isFavorite) {
		return 1;
	}

	return 2;
};

export const selectEligibleSnippets = (snippets: Snippet[]): Snippet[] =>
	snippets
		.filter(isValidQuickInsertSnippet)
		.sort((a, b) => getSortPriority(a) - getSortPriority(b));
